import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import { DriversTable } from "./DriversTable";

import { StateContext } from "../../contexts/Context";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
  },
  row: {
    display: "flex",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  phoneNumber: {
    marginLeft: "auto",
    width: 240,
  },
  btn: {
    marginLeft: theme.spacing(1),
    textTransform: "capitalize",
  },
}));

export const Agent = () => {
  const [drivers, setDrivers] = React.useState([]);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  const classes = useStyles();

  const { isWsConnected, websocket } = React.useContext(StateContext);

  const onChangePhoneNumber = React.useCallback((ev) => {
    setPhoneNumber(ev.target.value);
  }, []);

  const onGetDriverLocation = React.useCallback(() => {
    if (!isWsConnected || !phoneNumber) return;

    const body = JSON.stringify({
      data: {
        type: "agent",
        driver: phoneNumber,
      },
      action: "message",
    });
    websocket.send(body);
  }, [isWsConnected, phoneNumber, websocket]);

  const onReceiveMessage = React.useCallback((ev) => {
    const { driver, position } = JSON.parse(ev.data);

    if (driver && position) {
      const { latitude, longitude, accuracy } = position;
      setDrivers((prev) => [
        ...prev,
        {
          driver,
          latitude,
          longitude,
          "lat-lng": `${latitude}, ${longitude}`,
          accuracy: `${(+accuracy).toFixed(2)} m`,
        },
      ]);
    }
  }, []);

  React.useEffect(() => {
    if (websocket) {
      websocket.onmessage = onReceiveMessage;
    }
  }, [onReceiveMessage, websocket]);

  return (
    <>
      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12} className={classes.row}>
          <FormControl variant="outlined" className={classes.phoneNumber}>
            <InputLabel htmlFor="driver-phone-number">
              Enter driver's phone number
            </InputLabel>
            <Input
              id="driver-phone-number"
              value={phoneNumber}
              onChange={onChangePhoneNumber}
            />
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            onClick={onGetDriverLocation}
          >
            Get Driver's Location
          </Button>
        </Grid>
        <Grid item xs={12}>
          <DriversTable drivers={drivers} />
        </Grid>
      </Grid>
    </>
  );
};
